// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2smXd","header":"ReportDetails_header__yWtyM","title":"ReportDetails_title__1fLYn","left":"ReportDetails_left__33__-"};